export const COMPANY_NAME = "LEUCADIA WELLNESS BEAUTY LLC";
export const COMPANY_SHORT = "Leucadia Wellness Beauty";
export const COMPANY_INITIALS = "LWB";
export const COMPANY_ADDRESS_FULL = "5231 Bartlett Ave, San Gabriel, California, US 91776-2127";
export const COMPANY_LOCATION = "San Gabriel, CA";
export const COMPANY_REGION = "San Gabriel";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=5231%20Bartlett%20Ave%2C%20San%20Gabriel%2C%20California%2C%20US%2091776-2127";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1540555700478-4be289fbecef?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Organization", "value": "Wellness & beauty" },
  { "label": "Location", "value": "San Gabriel, California" },
  { "label": "Address", "value": "5231 Bartlett Ave" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "Leucadia Wellness Beauty LLC" },
  { "label": "Location", "value": "San Gabriel, California" },
  { "label": "Address", "value": "5231 Bartlett Ave, San Gabriel, California, US 91776-2127" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "Wellness", "body": "A general profile category reflecting the organization’s name." },
  { "icon": "✦", "title": "Beauty", "body": "A general profile category reflecting the organization’s name." },
  { "icon": "✿", "title": "Organization", "body": "Public directory information for Leucadia Wellness Beauty LLC." },
  { "icon": "❍", "title": "Location", "body": "Find the organization at its listed San Gabriel address." },
];
